<template>
  <div>
    <div :class="$style.box">
      <!-- 活动介绍 -->
      <Introduction v-show="introShow" @changeIntroShow="introChange"></Introduction>
      <!-- 页面标题 -->
      <Title :name="name" :type="1"></Title>
      <!-- 问题按钮 -->
      <img :class="$style.question" :src="question" @click="introChange" alt />
      <!-- 表单验证 -->
      <div :class="$style.bind">
        <Field
          :class="$style.field"
          v-for="(item, index) in fieldArray"
          :key="index"
          v-model="formData[item.model]"
          :index="item.index"
          :type="item.type"
          :info="item.info"
          :placeHolder="item.placeHolder"
          :disabled="item.disabled"
          :value="formData[item.model]"
          @showPopup="showPopup"
        ></Field>
        <div :class="$style.sure" @click="submit">确认</div>
        <div :class="$style.remove" @click="unbound">重新绑定账号</div>
      </div>
      <Popup v-model="popupShow" position="bottom">
        <Picker show-toolbar :columns="columns" :loading="loading" @confirm="onConfirm" />
      </Popup>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import Field from "@/components/Field.vue";
import Introduction from "@/components/Introduction.vue";
import { CDN_URL } from "@/config";
import { Picker, Popup, Toast } from "vant";
import { mapActions, mapState, mapMutations } from "vuex";
import { sort_ASCII, SET } from "@/libs/utils";
import '@vant/touch-emulator';

export default {
  data() {
    return {
      name: "角色选择", // 页面title
      question: `${CDN_URL}/packet/question.png`, // 问题icon
      introShow: false, // 活动介绍显示控制
      columns: null,
      gameArr: null, // 请求回来的游戏列表
      gameNameArr: [], // 游戏名称列表 用来做复选框
      serveArr: null, // 请求回来的角色列表
      serveNameArr: [], // 区服选择列表 用来做复选框
      roleArr: [], // 角色列表
      roleNameArr: [], // 角色选择列表 用来做复选框
      popupShow: false,
      loading: true,
      formData: {
        game: "",
        appkey: "",
        service: "",
        server_num: 0,
        role: ""
      },
      fieldIndex: 0, // 当前是哪个field
      fieldArray: [
        {
          index: 1,
          type: 2,
          info: "游戏",
          placeHolder: "选择您的游戏",
          disabled: true,
          model: "game"
        },
        {
          index: 2,
          type: 2,
          info: "区服",
          placeHolder: "选择您的区服",
          disabled: true,
          model: "service"
        },
        {
          index: 3,
          type: 2,
          info: "角色",
          placeHolder: "选择您的角色",
          disabled: true,
          model: "role"
        }
      ]
    };
  },
  components: {
    Title,
    Field,
    Introduction,
    Picker,
    Popup
  },
  computed: {
    ...mapState("packet", {
      userInfo: "userInfo",
      roleInfo: "roleInfo"
    })
  },
  mounted() {
    // 获取游戏列表
    this.getGameInfo();
  },
  methods: {
    ...mapActions("packet", {
      userRemove: "userRemove",
      getGame: "getGame",
      getRole: "getRole"
    }),
    ...mapMutations("packet", {
      CHANGE_ROLEINFO: "CHANGE_ROLEINFO",
      CLEAR_USERINFO_ID: "CLEAR_USERINFO_ID"
    }),
    // 点击确认
    submit() {
      if (!this.formData.game || !this.formData.service || !this.formData.role) return;
      this.$router.push({ name: "get" });
    },
    // 活动介绍
    introChange() {
      this.introShow = !this.introShow;
    },
    // 获取游戏列表
    async getGameInfo() {
      const r = await this.getGame();
      if (r.ret !== 1) {
        return;
      }
      this.gameArr = r.content;
      this.gameArr.forEach((item, index) => {
        this.gameNameArr[index] = item.show_name;
      });
      this.loading = false;
    },
    // 获取角色信息
    async getRoleInfo() {
      const r = await this.getRole(this.formData.appkey);
      if (r.ret !== 1) {
        return;
      }
      const set = new SET();
      this.serveArr = r.content;
      this.serveArr.forEach((item, index) => {
        set.push(item.server_name);
      });
      this.serveNameArr = set.arr;
      console.log("this.serveNameArr", this.serveNameArr);
      this.loading = false;
    },
    // 显示底部选择栏
    showPopup(index) {
      // 选择游戏才能继续选其他的
      switch (index) {
        case 1:
          this.fieldIndex = index;
          this.columns = this.gameNameArr;
          break;
        case 2:
          if (!this.formData.game) {
            Toast("请先选择游戏", 2000);
            return;
          }
          this.fieldIndex = index;
          this.columns = this.serveNameArr;
          break;
        case 3:
          if (!this.formData.game) {
            Toast("请先选择游戏", 2000);
            return;
          } else if (!this.formData.service) {
            Toast("请先选择区服", 2000);
            return;
          }
          this.fieldIndex = index;
          this.columns = this.roleNameArr;
          break;
      }
      this.popupShow = true;
    },
    async onConfirm(value, index) {
      const KEY = this.fieldArray[this.fieldIndex - 1].model;
      this.formData[KEY] = value;
      if (KEY === "game") {
        // 先清空之前的选择
        this.formData.role = "";
        this.formData.service = "";
        this.formData.server_num = "";
        this.serveArr = null; // 请求回来的角色列表
        this.serveNameArr = []; // 区服选择列表 用来做复选框
        this.roleArr = []; // 角色列表
        this.roleNameArr = [];
        const rightGame = this.gameArr.find(
          n => n.show_name === this.formData[KEY]
        );
        console.log("当前选中的游戏：", rightGame);
        this.formData.appkey = rightGame.appkey;
        // 获取该游戏下的用户信息
        await this.getRoleInfo();
      } else if (KEY === "service") {
        // 先清空之前的选择
        this.formData.role = "";
        this.roleArr = []; // 角色列表
        this.roleNameArr = [];
        this.serveArr.forEach((item, index) => {
          if (item.server_name === this.formData[KEY]) {
            this.formData.server_num = item.server_num;
            this.roleArr.push(item);
            this.roleNameArr.push(item.role_name);
          }
        });
        console.log("当前的角色列表：", this.roleNameArr);
      } else if (KEY === "role") {
        this.formData.role = value;
        if (this.roleArr[index].role_name === value) {
          console.log("匹配成功！舒服了");
          const roleInfo = Object.assign(this.roleArr[index], this.formData);
          console.log(roleInfo);
          this.CHANGE_ROLEINFO({
            roleInfo: roleInfo
          });
        }
      }
      this.popupShow = false;
    },
    // 解除绑定
    async unbound() {
      const { user_id, open_id } = this.userInfo;
      const data = {
        user_id: user_id,
        open_id: open_id
      };
      const r = await this.userRemove({
        ...data,
        sign: sort_ASCII(data)
      });
      if (r.ret === 1) {
        //  解绑成功
        this.CLEAR_USERINFO_ID();
        console.log("role remove", this.userInfo);
        this.$router.push({ name: "login" });
      }
      return;
    }
  }
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  .question {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 20px;
    top: 60px;
  }
  .bind {
    width: 100%;
    height: 300px;
    // background-color: pink;
    position: absolute;
    top: 180px;
    box-sizing: content-box;
    .field {
      margin-top: 20px;
      margin-left: 50%;
      transform: translateX(-113px);
    }
    .sure {
      width: 226px;
      height: 42px;
      background: rgba(255, 206, 100, 1);
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 30px;
    }
    .remove {
      position: absolute;
      font-size: 10px;
      color: #31b7f3;
      right: 80px;
      bottom: 20px;
    }
  }
}
</style>